import client from "./client";

export const livenessStatus = async () => (await client.get("/liveness/status")).data;
export const createLivenessSession = async () => (await client.post("/liveness/session")).data;
export const livenessCredentials = async () => (await client.get("/liveness/credentials")).data;
export const checkWithLiveness = async (body) => (await client.post("/liveness/check", body)).data;
export const testLiveness = async (session_id) => (await client.post("/liveness/test", { session_id })).data;
